import React from "react";
import { motion } from "framer-motion";

const WITHOUT = [
    "Агентство від $400/міс + % від бюджету",
    "2-4 тижні до першої кампанії",
    "Звіт раз на місяць якщо пощастить",
    "Ви не розумієте що відбувається",
    "При відмові — втрачаєте всі налаштування",
];

const WITH = [
    "Від $20/міс. Все включено.",
    "Перша кампанія за 20 хвилин",
    "AI-аналіз кожні 2-7 днів",
    "Бачите кожне рішення і чому",
    "Ваші дані залишаються завжди",
];

export const Comparison = () => {
    return (
        <section className="section" data-testid="comparison-section">
            <div className="container-mx">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <motion.div
                        initial={{ opacity: 0, x: -40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="glass rounded-2xl p-7"
                        style={{ borderColor: "rgba(248,113,113,0.2)" }}
                        data-testid="comp-without"
                    >
                        <h3 className="font-display font-bold text-xl text-text-primary">Без AutoAds</h3>
                        <ul className="mt-5 space-y-3">
                            {WITHOUT.map((w, i) => (
                                <li key={i} className="flex gap-3 text-sm text-text-primary/85">
                                    <span className="text-error-c font-mono shrink-0">→</span>
                                    <span>{w}</span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                        className="glass rounded-2xl p-7"
                        style={{ borderColor: "rgba(109,94,248,0.35)", boxShadow: "0 0 30px rgba(109,94,248,0.12)" }}
                        data-testid="comp-with"
                    >
                        <h3 className="font-display font-bold text-xl text-text-primary">З AutoAds</h3>
                        <ul className="mt-5 space-y-3">
                            {WITH.map((w, i) => (
                                <li key={i} className="flex gap-3 text-sm text-text-primary/95">
                                    <span className="text-primary-c font-mono shrink-0">→</span>
                                    <span>{w}</span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Comparison;
